module.exports = __webpack_public_path__ + "img/gzlb- 3.e51f0dfd.jpg";